angular.module("customer")
.controller("UnreadNotificationModalController", function($scope, $state, close) {
    $scope.filterUnread = true;

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.seeAllNotifications = function() {
        this.close();
        var params = {
            forceModalRedirect: true
        };

        if ($scope.unreadRemaining) {
            params['filterUnread'] = "1";
        }
        $state.go("notification-history", params);
    };

});



//////////////////
// WEBPACK FOOTER
// ./core/notification/unread-notification-modal/unread-notification.modal.js
// module id = 882
// module chunks = 0